module.exports = __webpack_public_path__ + "img/qm-bg.05454968.jpg";